<template>
    <div class="page-box">
        <el-form :model="form" ref="form" :rules="rules" label-width="0" :inline="false" size="normal">
            <el-form-item label="">
                <el-input type="password"  v-model="form.code" placeholder="请输入" clearable></el-input>
            </el-form-item>
        </el-form>

    </div>
</template>
<script>
export default {
    name: "check-code",
    data() {
        return {
            form: {
                code: ''
            },
            code: '6163',
            rules: {}
        };
    },
    methods: {
        confirm(callback, close) {
            if (this.form.code == this.code) {
                close();
                callback();
            }else{
                this.$message.error('操作码错误,请重试');
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.page-box {
    width: calc(100% - 20px);
    height: 80px;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>